/**
 * Transforms post-traitement pour fetchForecast.
 *
 * Un transform est un objet :
 *   {
 *     output: string,        // clé ajoutée au résultat
 *     inputs: string[],      // variables WMS nécessaires
 *     fn: (...values) => any // appelée pour chaque pas de temps
 *   }
 *
 * Les variables listées dans `inputs` sont récupérées normalement par
 * fetchForecast, puis combinées en une nouvelle clé `output`.
 * Les clés `inputs` restent présentes dans le résultat sauf si tu les
 * retires manuellement.
 */

// 1 noeud = 0.514791 m/s  (identique à Toutou_Thermo.js : this.knams)
const MS_TO_KT = 1 / 0.514791;

/**
 * Encode WSPD (m/s) + WD (degrés) dans le format entier d'imeteo :
 *   encoded = round(wspd_kt * 10) * 1000 + round(wd)
 *
 * Décodage côté imeteo (toutou_xy_vents.js) :
 *   force_kt = Math.floor(encoded / 1000) / 10
 *   force    = force_kt * unitJson.conv   (conv = 0.5148 pour m/s, 1 pour noeuds...)
 *   dir      = encoded - Math.floor(encoded/1000) * 1000  [degrés]
 */
export const IMETEO_UV = {
  output: 'uv',
  inputs: ['WSPD', 'WD'],
  fn: (wspd, wd) => {
    if (wspd === null || wd === null) return null;
    const wspd_kt = wspd * MS_TO_KT;
    return Math.round(wspd_kt * 10) * 1000 + Math.round(wd);
  },
};

/**
 * Facteur de conversion m/s → noeuds pour les rafales (WGE).
 * À appliquer via le champ scale dans HRDPS_PRODUCTS :
 *   scale: { WGE: WMS_MS_TO_KT }
 */
export { MS_TO_KT as WMS_MS_TO_KT };
